<template>
	<v-form ref="form" @submit.prevent="onSubmit">
		<slot></slot>
	</v-form>
</template>

<script lang="ts">
import { Component, Prop, Provide, ProvideReactive, Vue, Emit, Watch } from "vue-property-decorator";

interface ValidationForm {
	validate(): boolean;
	reset(): void;
	resetValidation(): void;
}

@Component
export default class Form extends Vue {
	@Prop({ type: Boolean, default: false }) saving: boolean;
	@Emit() submit() { }
	@Emit() error() { }

	isSaving: boolean = false;

	validate() {
		const form: ValidationForm = this.$refs.form as any;
		return form.validate();
	}

	reset() {
		const form: ValidationForm = this.$refs.form as any;
		form.reset();
	}

	resetValidation() {
		const form: ValidationForm = this.$refs.form as any;
		form.resetValidation();
	}

	@Watch("saving")
	onSavingChanged() {
		this.isSaving = this.saving;
	}

	@Provide()
	setFormSaving(isSaving: boolean = false) {
		this.isSaving = isSaving;
	}

	onSubmit() {
		if (this.isSaving)
			return;

		if (this.validate())
			this.submit();
		else this.error();
	}
}
</script>